import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://podium.botcenter.app/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const auth = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (email, password, name) => api.post('/auth/register', { email, password, name }),
  me: () => api.get('/auth/me'),
};

export const conferences = {
  getAll: () => api.get('/conferences'),
  getOne: (id) => api.get(`/conferences/${id}`),
  create: (data) => api.post('/conferences', data),
  update: (id, data) => api.put(`/conferences/${id}`, data),
  delete: (id) => api.delete(`/conferences/${id}`),
};

export const presentations = {
  upload: (conferenceId, formData) =>
    api.post(`/conferences/${conferenceId}/presentations`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  updateOrder: (conferenceId, presentations) =>
    api.put(`/conferences/${conferenceId}/presentations/order`, { presentations }),
  delete: (conferenceId, id) =>
    api.delete(`/conferences/${conferenceId}/presentations/${id}`),
createPause: (conferenceId, data) =>
    api.post(`/conferences/${conferenceId}/presentations/pause`, data),
update: (conferenceId, id, data) =>
    api.put(`/conferences/${conferenceId}/presentations/${id}`, data),
};

export const qr = {
  generate: (conferenceId) => api.post(`/qr/${conferenceId}/qr`),
  getProgram: (token) => api.get(`/qr/p/${token}`),
  getDownloads: (token) => api.get(`/qr/d/${token}`),
};

export default api;
